import { useContext, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import * as FormWizardStyles from '../../../../components/organisms/FormWizard/styles'
import { FormWizardHandlers } from '../../../../components/organisms/FormWizard'
import { LoadingIndicator } from '../../../../components/atoms/LoadingIndicator'
import { Link } from 'react-router-dom'
import { usePermissions } from '../../../../hooks/usePermissions'
import { CreateSpeContext } from '../index'

import * as S from './styles'
import checkCircleIcon from '../../../../assets/images/check-circle.svg'

export default function Step5({ backHandler }: FormWizardHandlers) {
  const { can } = usePermissions()
  const { submitStatus } = useContext(CreateSpeContext)

  // backend recusou: volta ao passo anterior (dados mantidos); o toast com o
  // motivo é disparado pela tela
  useEffect(() => {
    if (submitStatus === 'error') backHandler()
  }, [submitStatus])

  if (submitStatus !== 'success') {
    return (
      <FormWizardStyles.TabContent>
        <S.Wrapper>
          <LoadingIndicator />
        </S.Wrapper>
      </FormWizardStyles.TabContent>
    )
  }

  return (
    <FormWizardStyles.TabContent>
      <S.Wrapper>
        <img src={checkCircleIcon} />
        <p>
          <strong>Dados da SPE cadastrados com sucesso!</strong>
        </p>
        {can.create('projects') ? (
          <>
            <p>
              Você já pode cadastrar um Empreendimento associado a essa SPE.
              Deseja fazer isso agora?
            </p>
            <Link to="/projects/create">
              <Button variant="primary">Cadastrar Empreendimento</Button>
            </Link>
          </>
        ) : (
          <p>SPE criada com sucesso!</p>
        )}

        <Link to="/spes">
          <a>Ver SPE</a>
        </Link>
      </S.Wrapper>
    </FormWizardStyles.TabContent>
  )
}
